import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

export default function NotFound() {
  const { pathname } = useLocation();

  return (
    <>
      <title>Page not found | AUREN Management Consulting</title>
      <meta name="robots" content="noindex" />
      <Navbar />
      <main className="bg-background-50 pt-14 min-h-[70vh]">
        <div className="wrap pt-24 md:pt-36 pb-24">
          <span className="label-xs text-foreground-600">404 / Not found</span>
          <h1 className="mt-6 font-heading font-light uppercase leading-[1] tracking-[0.02em] text-foreground-950 text-[clamp(34px,5vw,64px)] max-w-[16ch]">This page isn&rsquo;t available.</h1>
          <p className="mt-6 text-[15px] text-foreground-600 break-all">{pathname}</p>
          <Link to="/" className="group mt-10 inline-flex items-center gap-4 label-xs text-foreground-950 cursor-pointer whitespace-nowrap">
            Back to home<span className="circle-arrow inv-dark"><i className="ri-arrow-right-line" /></span>
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}